export const SET_SESSION = "session/SET_SESSION";
export const SET_SESSION_SUCCESS = "session/SET_SESSION_SUCCESS";
export const SET_SESSION_FAIL = "session/SET_SESSION_FAIL";
export const CLEAR_SESSION = "session/CLEAR_SESSION";
export const CHANGE_DELIVERY_AREA = "session/CHANGE_DELIVERY_AREA";
export const CHANGE_DELIVERY_AREA_SUCCESS = "session/CHANGE_DELIVERY_AREA_SUCCESS";
export const CHANGE_DELIVERY_AREA_FAIL = "session/CHANGE_DELIVERY_AREA_FAIL";
